import * as angular from 'angular';

import { ComponentDefinition, IApiInformation } from '../../../models';
import { IStoreService } from '../../../services';
import { StoreElement } from '../../../stateManagement';

class ConfigurationStateController implements angular.IComponentController {
    apiInformation: IApiInformation;
    isLoading: boolean;

    private _unsubscribe: () => void;

    static $inject = [
        'storeService'
    ];

    constructor(
        private _storeService: IStoreService
    ) {
    }

    $onInit() {
        this.isLoading = true;
        this._unsubscribe = this._storeService.register(
            store => {
                this.apiInformation = store.apiInformation.value;
                this.isLoading = false;
            },
            [StoreElement.ApiInformation]
        );
    }

    $onDestroy() {
        this._unsubscribe();
    }
}

export const wtConfigurationState: ComponentDefinition = {
    componentId: 'wtConfigurationState',
    controller: ConfigurationStateController,
    template: require('./configurationState.component.html'),
    controllerAs: 'vm',
    bindings: {
    }
};